import { render, staticRenderFns } from "./Secciones.vue?vue&type=template&id=1819c192&"
import script from "./Secciones.vue?vue&type=script&lang=js&"
export * from "./Secciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports